<template>
  <base-material-card
    :icon="icon"
    class="v-card--material-stats"
    v-bind="$attrs"
    v-on="$listeners"

  >
    <template v-slot:after-heading>
      <div class="ml-auto text-right">
        <div
          class="grey--text font-weight"
          style="font-size: 14px"
          v-text="title"
        />

        <h3 class="display-2 font-weight text--primary">
          {{ competencia }}
        </h3>
      </div>
    </template>

    <v-col cols="12" class="px-0">
      <v-divider />
    </v-col>

    <div style="display: flex; align-items: center; justify-content: space-between; width: 100%;">
      <div >
        <v-icon color="green" size="18" class="ml-2 mr-1">
          mdi-cash-multiple
        </v-icon>
        <span
          style="font-size: 12px"
          class="font-weight"
        >
          {{ valorTotal }}
        </span>
      </div>
      
      <v-btn
        v-if="showReopenButton"
        small
        color="secondary"
        class="mr-2"
        @click="$emit('reabrir-click')"
        title="Reabrir período"
      >
        <v-icon left small>mdi-lock-open-variant</v-icon>
        Reabrir
      </v-btn>
    </div>

    <v-col cols="12" class="px-0 pb-0">
      <v-expansion-panels flat>
        <v-expansion-panel>
          <v-expansion-panel-header class="px-2 py-1 pb-0" style="min-height: 36px">
            <span style="font-size: 12px" class="font-weight">
              <v-icon small class="mr-1">mdi-information-outline</v-icon>
              Ver mais detalhes
            </span>
          </v-expansion-panel-header>
          <v-expansion-panel-content >
            <div class="mt-2">
              <div style="font-size: 12px" class="mb-1">
                <strong>Empresa:</strong> {{ empresa }}
              </div>
              <div style="font-size: 12px" class="mb-1">
                <strong>Finalizado por:</strong> {{ finalizadoPor }}
              </div>
              <div style="font-size: 12px" class="mb-1">
                <strong>Data:</strong> {{ dataFinalizacao }}
              </div>
              <div style="font-size: 12px" class="mb-1">
                <strong>Valor Total:</strong> {{ valorTotal }}
              </div>
              <div style="font-size: 12px">
                <strong>Colaboradores:</strong> {{ quantidadeColaboradores }}
              </div>
            </div>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-col>
  </base-material-card>
</template>

<script>
import Card from "./Card";

export default {
  name: "MaterialLoteCard",

  inheritAttrs: false,

  props: {
    ...Card.props,
    icon: {
      type: String,
      default: "mdi-lock-check",
    },
    title: {
      type: String,
      default: "Período Finalizado",
    },
    competencia: {
      type: String,
      required: true,
    },
    empresa: {
      type: String,
      required: true,
    },
    finalizadoPor: {
      type: String,
      default: "Sistema",
    },
    dataFinalizacao: {
      type: String,
      required: true,
    },
    valorTotal: {
      type: String,
      required: true,
    },
    quantidadeColaboradores: {
      type: [Number, String],
      default: 0,
    },
    showReopenButton: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="sass">
.v-card--material-stats
  display: flex
  flex-wrap: wrap
  position: relative

  > div:first-child
    justify-content: space-between

  .v-card
    border-radius: 4px
    flex: 0 1 auto

  .v-card__text
    display: inline-block
    flex: 1 0 calc(100% - 120px)
    position: absolute
    top: 0
    right: 0
    width: 100%

  .v-card__actions
    flex: 1 0 100%

  .v-expansion-panel-content__wrap
    padding-left: 10px !important
    padding-right: 0 !important
</style>
